import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../../services'
import { WaterSystemGeoBlocksInitialState } from '../waterSystemGeoBlocks.slice'

export const createWaterSystemGeoBlocksAsync = createAsyncThunk(
  'coordinates/waterSystemGeoBlocks',
  async (geoblockIds: string[], { rejectWithValue }) => {
    try {
      const req = await EpaApi.createWaterSystemGeoBlocks(geoblockIds)
      return (req as AxiosResponse<any, any>).data
    } catch (error: any) {
      console.error(error)
      return rejectWithValue({message:"unknown error occured"})
    }
  },
)

export const createWaterSystemGeoBlocksAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterSystemGeoBlocksInitialState>,
) => {
  builder.addCase(createWaterSystemGeoBlocksAsync.pending, (state, action) => {
    state.loading = true
    state.success = false
    state.error = ''
  })
  builder.addCase(createWaterSystemGeoBlocksAsync.fulfilled, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.data = action.payload
  })
  builder.addCase(createWaterSystemGeoBlocksAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = true
    state.error = action.payload
  })
}
